import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-petition',
  templateUrl: './petition.component.html',
  styleUrls: ['./petition.component.css']
})
export class PetitionComponent implements OnInit {

  
  constructor() { }

  ngOnInit() {
   
  }

}



// WEBPACK FOOTER //
// ./src/app/petition/petition.component.ts